let loading: Promise<typeof import("./firebaseDeferred")> | null = null;
export function loadFirebase() {
  return (loading ??= import("./firebaseDeferred").catch(error => {
    loading = null;
    throw error;
  }));
}
